import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "Center.SelectAppointmentAddOnsForm.title",
    defaultMessage: "Add some extras",
  },
});
